import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { Reveal } from "@/components/shared/Reveal";

const SLIDES = [
  { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_landing-hub-908/artifacts/10049ae71aa943df_image-2.jpeg", label: "Owner-Operators — Run your fleet from the cab" },
  { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_landing-hub-908/artifacts/246c939a1e406200_image-3.png", label: "Fleet Dashboard — always know your status" },
  { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_landing-hub-908/artifacts/f8ad578a7154ba00_image-3.jpeg", label: "Carriers & Brokers — post loads, manage drivers" },
  { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_landing-hub-908/artifacts/d1d3bfa1000f3e50_image-4.png", label: "Driver Network — drive, earn, belong" },
  { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_landing-hub-908/artifacts/8336e6d2b2eadd19_image-1%20%282%29.png", label: "Relief loads near you, on demand" },
];

export const AppShowcase = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setActive((a) => (a + 1) % SLIDES.length), 5000);
    return () => clearInterval(t);
  }, []);

  const go = (delta) => setActive((a) => (a + delta + SLIDES.length) % SLIDES.length);

  return (
    <section data-testid="app-showcase-section" className="py-24 md:py-32 bg-rr-surface overflow-hidden">
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <SectionHeading eyebrow="App Preview" title="See RelayRigs In Action." testId="app-showcase" />
        <Reveal delay={0.1}>
          <div className="relative mt-10 rounded-2xl md:rounded-[2rem] overflow-hidden shadow-2xl border border-rr-line aspect-[16/9] bg-rr-navy">
            <AnimatePresence mode="wait">
              <motion.img
                key={active}
                src={SLIDES[active].src}
                alt={SLIDES[active].label}
                initial={{ opacity: 0, scale: 1.02 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
                className="absolute inset-0 w-full h-full object-contain"
                data-testid="app-showcase-image"
              />
            </AnimatePresence>

            <button
              onClick={() => go(-1)}
              data-testid="app-showcase-prev-button"
              aria-label="Previous"
              className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-black/40 hover:bg-black/60 text-white flex items-center justify-center backdrop-blur-sm transition-colors"
            >
              <ChevronLeft size={18} />
            </button>
            <button
              onClick={() => go(1)}
              data-testid="app-showcase-next-button"
              aria-label="Next"
              className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-black/40 hover:bg-black/60 text-white flex items-center justify-center backdrop-blur-sm transition-colors"
            >
              <ChevronRight size={18} />
            </button>
          </div>

          <div className="flex items-center justify-center gap-2 mt-6">
            {SLIDES.map((s, i) => (
              <button
                key={s.label}
                onClick={() => setActive(i)}
                data-testid={`app-showcase-dot-${i}`}
                aria-label={s.label}
                className={`h-1.5 rounded-full transition-all ${i === active ? "w-8 bg-rr-orange" : "w-3 bg-rr-line"}`}
              />
            ))}
          </div>
          <p className="text-center text-sm text-rr-muted mt-3 min-h-[20px]">{SLIDES[active].label}</p>
        </Reveal>
      </div>
    </section>
  );
};
